<template>
  <div class="datepicker" @touchmove.prevent>
    <transition name="fade" mode="out-in">
      <div class="pickerBoxBg" v-show="show" @click=" show = false" @touchmove="_stopDef" @mousewheel="_stopDef">
        <div class="pickerBox" v-show="show" @mousewheel="_stopDef">
          <div class="pickerBoxWrapper">
            <div class="pickerBoxTitle">
              <div @click="esc">取消</div>
              <div @click.stop="submit">确认</div>
            </div>
            <div class="pickerBoxContent">
              <div class="pickerBoxContentList">
                <ul :class="{'first_dragging': yearState.dragging}" @touchstart="_onTouchStart('year', $event)"
                  @mousedown="_onTouchStart('year', $event)"
                  :style="{'transform' : 'translate3d(0,' + yearState.translateY + 'px, 0)'}">
                  <li></li>
                  <li></li>
                  <li></li>
                  <li ref="list-box" v-for="(item, index)
                  in yearState.data" :key="index" :class="{
                      'current': item === yearState.selectedId,
                      'node1':  Math.abs(index - yearState.index) == 1,
                      'node2':  Math.abs(index - yearState.index) == 2,
                      'node3':  Math.abs(index - yearState.index) >= 3
                  }">
                    {{item}}年
                  </li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
              </div>
              <div class="pickerBoxContentList">
                <ul :class="{'second_dragging': monthState.dragging}" @touchstart="_onTouchStart('month', $event)"
                  @mousedown="_onTouchStart('month', $event)"
                  :style="{'transform' : 'translate3d(0,' + monthState.translateY + 'px, 0)'}">
                  <li></li>
                  <li></li>
                  <li></li>
                  <li v-for="(item, index) in monthState.data" :key="index" :class="{
                          'current': item === monthState.selectedId,
                          'node1':  Math.abs(index - monthState.index) == 1,
                          'node2':  Math.abs(index - monthState.index) == 2,
                          'node3':  Math.abs(index - monthState.index) >= 3
                  }">
                    {{item}}月
                  </li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
              </div>
              <div class="pickerBoxContentList">
                <ul ref:area-list :class="{'third_dragging': dayState.dragging}"
                  @touchstart="_onTouchStart('day', $event)" @mousedown="_onTouchStart('day', $event)"
                  :style="{'transform' : 'translate3d(0,' + dayState.translateY + 'px, 0)'}">
                  <li></li>
                  <li></li>
                  <li></li>
                  <li v-for="(item, index) in dayState.data" :key="index" :class="{
                      'current': item === dayState.selectedId,
                      'node1':  Math.abs(index - dayState.index) == 1,
                      'node2':  Math.abs(index - dayState.index) == 2,
                      'node3':  Math.abs(index - dayState.index) >= 3
                  }">
                    {{item}}日
                  </li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
              </div>

            </div>
            <div class="currentDateBg"></div>
            <!-- <hr class="ProvCitySelectedTop">
            <hr class="ProvCitySelectedBottom"> -->
          </div>

        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { Toast } from 'vant';


export default {
  data: function () {
    return {
      show: this.propsShow,
      result: this.propsResult,
      firstShow: true,
      target: '',
      yearState: {
        data: null,
        selectedId: null,
        index: 0,
        startPos: null,
        translateY: 0,
        startTranslateY: 0,
        dragging: false
      },
      monthState: {
        data: null,
        selectedId: null,
        index: 0,
        startPos: null,
        translateY: 0,
        startTranslateY: 0,
        dragging: false
      },
      dayState: {
        data: null,
        selectedId: null,
        index: 0,
        startPos: null,
        translateY: 0,
        startTranslateY: 0,
        dragging: false
      },
      hourState: {
        data: [],
        selectedId: null,
        index: 0,
        startPos: null,
        translateY: 0,
        startTranslateY: 0,
        dragging: false
      },
      minuteState: {
        data: [],
        selectedId: null,
        index: 0,
        startPos: null,
        translateY: 0,
        startTranslateY: 0,
        dragging: false
      },
      delta: 0,
      slideEls: null
    };
  },
  mounted: function () {
    this.initData();

    this._onTouchMove = this._onTouchMove.bind(this);
    this._onTouchEnd = this._onTouchEnd.bind(this);
  },
  methods: {
    computedYear () {
      const year = this.endYear ? this.endYear : new Date().getFullYear();
      let yearData = [];

      for (let i = this.startYear; i <= year; i++) {
        yearData.push(i);
      }

      return yearData;
    },
    computedMonth () {
      let monthData = [];

      const startControl = this.startControlComputed();
      const endControl = this.endControlComputed();
      const sameResult = this.sameComputed();

      // 开始年份限制 计算最小月
      if (startControl.yearFlag && !sameResult.sameYear) {
        const minMonth = this.startMonth;
        for (let i = minMonth; i <= 12; i++) {
          monthData.push(i);
        }
        return monthData;
      }
      // 结束年份限制 计算最大月
      if (endControl.yearFlag && !sameResult.sameYear) {
        const maxMonth = this.endMonth;
        for (let i = 1; i <= maxMonth; i++) {
          monthData.push(i);
        }
        return monthData;
      }
      // 开始与结束年份限制， 且年份相同 计算最小月-最大月
      if (startControl.yearFlag && endControl.yearFlag && sameResult.sameYear) {
        const minMonth = this.startMonth;
        const maxMonth = this.endMonth;
        for (let i = minMonth; i <= maxMonth; i++) {
          monthData.push(i);
        }
        return monthData;
      }

      // 无限制
      for (let i = 1; i <= 12; i++) {
        monthData.push(i);
      }

      return monthData;
    },
    computedDay () {
      let dayData = [];
      const year = this.yearState.selectedId;
      const month = this.monthState.selectedId;
      const current = new Date(year, month, 0);
      var currentDay = current.getDate();

      const startControl = this.startControlComputed();
      const endControl = this.endControlComputed();
      const sameResult = this.sameComputed();

      const startFlag = startControl.yearFlag && startControl.monthFlag;
      const endFlag = endControl.yearFlag && endControl.monthFlag;
      const startEndSame = sameResult.sameYear && sameResult.sameMonth;

      // 开始年月限制 计算最小日
      if (startFlag && !startEndSame) {
        const minDay = this.startDay;
        for (let i = minDay; i <= currentDay; i++) {
          dayData.push(i);
        }
        return dayData;
      }

      // 结束年月限制 计算最最大日
      if (endFlag && !startEndSame) {
        const maxDay = this.endDay;
        for (let i = 1; i <= maxDay; i++) {
          dayData.push(i);
        }
        return dayData;
      }

      // 开始年月和结束年月限制 计算最小日-最大日
      if (startFlag && endFlag && startEndSame) {
        const minDay = this.startDay;
        const maxDay = this.endDay;
        for (let i = minDay; i <= maxDay; i++) {
          dayData.push(i);
        }
        return dayData;
      }

      // 无限制
      for (let i = 1; i < currentDay + 1; i++) {
        dayData.push(i);
      }
      return dayData;
    },
    startControlComputed () {
      let startControlResult = {};
      startControlResult.yearFlag = this.yearState.selectedId === this.startYear;
      startControlResult.monthFlag = this.monthState.selectedId === this.startMonth;
      return startControlResult;
    },
    endControlComputed () {
      let endControlResult = {};
      endControlResult.yearFlag = this.yearState.selectedId === this.endYear;
      endControlResult.monthFlag = this.monthState.selectedId === this.endMonth;
      return endControlResult;
    },
    sameComputed () {
      let sameResult = {};
      sameResult.sameYear = this.startYear === this.endYear;
      sameResult.sameMonth = this.startMonth === this.endMonth;
      return sameResult;
    },
    initData () {
      const curDate = new Date();
      const yearState = this.yearState;
      const monthState = this.monthState;
      const dayState = this.dayState;
      yearState.data = this.computedYear();
      yearState.selectedId = curDate.getFullYear();

      this.filterMonth();
      monthState.selectedId = curDate.getMonth() + 1;

      this.filterDay();
      dayState.selectedId = curDate.getDate();
      this.setHour();
      this.setMinute();
    },
    transToToday () {
      const yearState = this.yearState;
      const monthState = this.monthState;
      const dayState = this.dayState;
      const hourState = this.hourState;
      const minuteState = this.minuteState;

      this.$nextTick(() => {
        setTimeout(() => {
          const height = this.$refs['list-box'][0].getBoundingClientRect().height;
          for (let i = 0; i < yearState.data.length; i++) {
            if (yearState.selectedId === yearState.data[i]) {
              yearState.index = i;
            }
          }
          yearState.translateY = -height * yearState.index;

          for (let i = 0; i < monthState.data.length; i++) {
            if (monthState.selectedId === monthState.data[i]) {
              monthState.index = i;
            }
          }
          monthState.translateY = -height * monthState.index;

          for (let i = 0; i < dayState.data.length; i++) {
            if (dayState.selectedId === dayState.data[i]) {
              dayState.index = i;
            }
          }
          dayState.translateY = -height * dayState.index;
          for (let i = 0; i < hourState.data.length; i++) {
            if (hourState.selectedId === hourState.data[i]) {
              hourState.index = i;
            }
          }
          hourState.translateY = -height * hourState.index;
          for (let i = 0; i < minuteState.data.length; i++) {
            if (minuteState.selectedId === minuteState.data[i]) {
              minuteState.index = i;
            }
          }
          minuteState.translateY = -height * minuteState.index;
        }, 300);
      });
    },
    submit () {

      this.result = {
        'year': this.yearState.data[this.yearState.index],
        'month': this.monthState.data[this.monthState.index],
        'day': this.dayState.data[this.dayState.index],
        'hour': this.hourState.data[this.hourState.index],
        'minute': this.minuteState.data[this.minuteState.index],
        'title': this.title
      };

      console.log(this.result);
      let currentDate = new Date();
      let selectDate = new Date(`${this.result.year}/${this.result.month}/${this.result.day}`)
      if (selectDate > currentDate) {
        Toast('日期不能大于今天')
        return
      }



      this.$emit('setDate', this.result);
      this.show = false;
      this.initData();
      this._onTouchMove = this._onTouchMove.bind(this);
      this._onTouchEnd = this._onTouchEnd.bind(this);
    },
    esc () {
      this.show = false;
      this.$emit('escDate');
      this.initData();
      this._onTouchMove = this._onTouchMove.bind(this);
      this._onTouchEnd = this._onTouchEnd.bind(this);
    },
    filterMonth () {
      this.monthState.data = this.computedMonth();

      this.monthState.selectedId = this.monthState.data[0];
      this.monthState.translateY = 0;
      this.monthState.index = 0;
    },
    filterDay () {
      this.dayState.data = this.computedDay();

      this.dayState.selectedId = this.dayState.data[0];
      this.dayState.translateY = 0;
      this.dayState.index = 0;
    },
    getSelectedData (index) {
      let target = this.target;
      let thisData = this[target + 'State'];
      thisData.selectedId = thisData.data[index];

      if (target === 'year') {
        this.filterMonth();
        this.filterDay();
      }
      if (target === 'month') {
        this.filterDay();
      }
    },
    setHour () {
      for (let i = 0; i < 24; i++) {
        if (i < 10) {
          this.hourState.data.push('0' + i);
        } else {
          this.hourState.data.push(i);
        }
      }
      let oDate = new Date();
      this.hourState.selectedId = oDate.getHours();
      this.hourState.translateY = 0;
      this.hourState.index = 0;
    },
    setMinute () {
      for (let i = 0; i < 60; i++) {
        if (i < 10) {
          this.minuteState.data.push('0' + i);
        } else {
          this.minuteState.data.push(i);
        }
      }
      let oDate = new Date();
      let Currnetminute = oDate.getMinutes();
      if (Currnetminute < 10) {
        Currnetminute = '0' + Currnetminute;
      }
      this.minuteState.selectedId = Currnetminute;
      this.minuteState.translateY = 0;
      this.minuteState.index = 0;
    },
    setPage () {
      let target = this.target;
      let thisData = this[target + 'State'];
      let clientHeight = this.slideEls[0].getBoundingClientRect().height;
      let total = thisData.data.length;
      let goPage = Math.round((thisData.translateY / clientHeight).toFixed(1));
      if (goPage > 0) {
        goPage = 0;
      }
      goPage = total - 1 >= Math.abs(goPage) ? goPage : -(total - 1);
      let index = Math.abs(goPage);
      thisData.index = index;
      this.getSelectedData(index);
      thisData.translateY = goPage * clientHeight;
    },
    _getTouchPos (e) {
      return e.changedTouches ? e.changedTouches[0]['pageY'] : e['pageY'];
    },
    _getElem (e) {
      return Array.from(e.currentTarget.children).slice(3, -3);
    },
    _onTouchStart (target, e) {
      let thisData = this[target + 'State'];
      this.target = target;
      this.slideEls = this._getElem(e);
      this.delta = 0;
      thisData.startPos = this._getTouchPos(e);
      thisData.startTranslateY = thisData.translateY;
      thisData.dragging = true;
      document.addEventListener('touchmove', this._onTouchMove, false);
      document.addEventListener('touchend', this._onTouchEnd, false);
      document.addEventListener('mousemove', this._onTouchMove, false);
      document.addEventListener('mouseup', this._onTouchEnd, false);
    },
    _onTouchMove (e) {
      let target = this.target;
      let thisData = this[target + 'State'];
      this.delta = this._getTouchPos(e) - thisData.startPos;
      thisData.translateY = thisData.startTranslateY + this.delta;
      if (Math.abs(this.delta) > 0) {
        e.preventDefault();
      }
    },
    _onTouchEnd (e) {
      let target = this.target;
      let thisData = this[target + 'State'];
      thisData.dragging = false;
      this.setPage();
      document.removeEventListener('touchmove', this._onTouchMove);
      document.removeEventListener('touchend', this._onTouchEnd);
      document.removeEventListener('mousemove', this._onTouchMove);
      document.removeEventListener('mouseup', this._onTouchEnd);
    },
    _stopDef (e) {
      e.preventDefault();
    }
  },
  watch: {
    propsShow: function (newVal) {
      this.show = newVal;
    },
    show: function (newVal) {
      this.$emit('setDialogVisible', newVal);
      this.transToToday();
      // if (this.firstShow) {
      //   this.transToToday();
      //   this.firstShow = false;
      // }
    }
  },
  props: {
    'propsResult': {
      type: Object,
      default: null
    },
    'propsShow': {
      type: Boolean,
      default: false
    },
    'startYear': {
      type: Number,
      default: 2000
    },
    'startMonth': {
      type: Number,
      default: 1
    },
    'startDay': {
      type: Number,
      default: 1
    },
    'endYear': {
      type: Number,
      default: null
    },
    'endMonth': {
      type: Number,
      default: null
    },
    'endDay': {
      type: Number,
      default: null
    },
    'title': {
      type: String,
      default: '请选择'
    },
    'confirm': {
      type: String,
      default: '确定'
    },
    'cancel': {
      type: String,
      default: '取消'
    }
  }
};
</script>

<style lang="less" >
.datepicker {
  width: 100%;
  height: 100%;

  .pickerBoxBg {
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, .35);
    z-index: 200;
    position: fixed;
    top: 0;
    left: 0;
  }

  .pickerBox {
    position: absolute;
    bottom: 0;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
    z-index: 300;
    background: #fff;
    width: 670px;
    border-radius: 40px;

    width: 750px;
    height: 578px;
    background: #FFFFFF;
    border-radius: 32px 32px 0px 0px;


    .pickerBoxWrapper {

      margin: 0 auto;
    }

    .pickerBoxTitle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100px;
      padding-left: 92px;
      padding-right: 92px;
      overflow: hidden;
      border-bottom: 2px solid #28272A08;

      div {
        height: 44px;
        font-size: 32px;
        margin-top: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #619CF5;
        line-height: 44px;
      }
    }
  }


  .pickerBoxContent {
    margin: 0 auto;
    overflow: hidden;
    height: 350px;
    overflow: hidden;
    display: flex;
    margin-top: 80px;
    position: relative;
    z-index: 3;
  }

  .pickerBoxContentList {
    flex-grow: 1;
    text-align: center;

    ul {
      -webkit-transition: all .3s ease;
      transition: all .3s ease;
      height: 44px;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 44px;


      &.first_dragging,
      &.second_dragging,
      &.third_dragging {
        -webkit-transition: none;
        transition: none;
      }

      li {
        line-height: 65px;
        height: 65px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &.current {
          height: 56px;
          font-size: 40px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #323232;
          line-height: 56px;
        }

        &.node1 {
          font-size: 28) !important;
          opacity: .7;
        }

        &.node2 {
          font-size: 26) !important;
          opacity: .5;
        }

        &.node3 {
          font-size: 24px !important;
          opacity: .3;
        }
      }
    }
  }

  .currentDateBg {
    height: 80px;
    background-color: #D8EFFD;
    position: absolute;
    bottom: 135px;
    width: 100%;
  }

  .ProvCitySelectedTop {
    width: 562px;
    border: none;
    border-top: 1px solid #eee;
    position: absolute;
    bottom: 294px;
    margin: 0;
    height: 0;


  }

  .ProvCitySelectedBottom {
    width: 562px;
    border: none;
    border-top: 1px solid #eee;
    position: absolute;
    bottom: 220px;
    margin: 0;
    height: 0;
  }
}
</style>